import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import "./FormGroup.scss";
import FormBottom from "../form-bottom/FormBottom";
import FormSection from "../form-section/FormSection";
import { BLOCKS, INLINES } from "@contentful/rich-text-types";
import rawToReact from "../../../utils/rawToReact";
import checkSvg from "../../../../src/assets/images/icons/check-magenta.png";

import useBrowserMode from "../../../shared/hooks/useBrowserMode"
import { set } from "react-hook-form";

interface IGroupForm {
    titulosFormulario: Array<any>;
    tituloBoton?: string;
    activeIndex: number;
    onclick?: () => any,
    setActiveIndex: Dispatch<SetStateAction<number>>;
    activeWizard: boolean;
    endIndex: number;
    setInputValue: any;
    formValues: any;
    handleSubmitForm: any;
    inputDisabled: string[];
    fieldsToSkip?: string[];
    validBirthDate?: boolean;
    isDisabledButton?: boolean;
    handleEvent?: any;
    dateState?: any;
    talleresData?: any;
    childHeader?: any;
    getActiveIndex?: (index: number) => void;
    setDuration?: (value: string) => void;
    handleCancelButton?: any;
    setCurrentIndex?: any;
    childOptions?: any;
    optionEdit?:boolean;
    setOptionEdit?:any;
    positionIndex?:any;
    dateStateHelper?:boolean;
    setDateStateHelper?:any;
    alertMessage?:boolean;
    ageAlert?:boolean;
    setDisableStep?:any;
}

interface IErrorMessage {
    nombreId: string;
    errorMessage: string;
}

const FormGroup = (props: IGroupForm) => {
    const {
        titulosFormulario,
        tituloBoton,
        activeIndex,
        onclick,
        setActiveIndex,
        activeWizard,
        endIndex,
        setInputValue,
        formValues,
        handleSubmitForm,
        inputDisabled,
        validBirthDate,
        isDisabledButton,
        fieldsToSkip,
        handleEvent,
        dateState,
        talleresData,
        childHeader,
        getActiveIndex,
        setDuration,
        handleCancelButton,
        setCurrentIndex,
        childOptions,
        optionEdit,
        setOptionEdit,
        positionIndex,
        dateStateHelper,
        setDateStateHelper,
        alertMessage,
        ageAlert,
        setDisableStep,
    } = props;
    
    // Estados para las validaciones basicas de los inputs.
    const [inputsErrorList, setInputErrorList] = useState<string[]>([]);
    const [customErrorMessageList, setCustomErrorMessageList] = useState<IErrorMessage[]>([]);
    const [showGreenAdvice, setShowGreenAdvice] = useState(false);
    const [showLileAdvice, setShowLileAdvice] = useState(true);

    const [aceptarTratamiento, setAceptarTratamiento] = useState(null);

    let selectorSelectMunicipalities: any = null;
    let selectorSelectDeparment: any = null;
    let selectorButtonSiguiente: any = null;

    const { isBrowser, window} = useBrowserMode();
    const pathName = isBrowser ? window.location.pathname.split('/')[5] : ''
    const pathNameMentoria = isBrowser ? window.location.pathname.split('/')[3] : ''
    const pathNameGeneral = window.location.pathname;
    
    //Deshabilita botón de continuar hasta que se completen los campos en cada seccion
    const [disableBottom, setdisableBottom] = useState(true);
    
    const groupBy = (list, key) => {
        return list.reduce(function (rv, x) {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        }, {});
    };

    const listCityAmva = [
        "MEDELLIN",
        "BARBOSA",
        "BELLO",
        "CALDAS",
        "COPACABANA",
        "ENVIGADO",
        "GIRARDOTA",
        "ITAGUI",
        "LA CEJA",
        "LA ESTRELLA",
        "EL RETIRO",
        "RIONEGRO",
        "SABANETA",
    ];
    
    // Validaciones para los inputs
    const inputValidation = (type, value, nombreId) => {
        switch (type) {
            case "email":
                if (
                    !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                        value
                        ) &&
                        value
                        ) {
                            setCustomErrorMessageList((prev: any) => [
                                ...prev,
                                { nombreId, errorMessage: "* El correo no es válido." },
                            ]);
                            
                            return true;
                        } else {
                            return false;
                        }
                        
            case "mobile":
                // Valida que el input contenga minimo 10 digitos
                if (value?.length != 10 && value) {
                    setCustomErrorMessageList((prev: any) => [
                        ...prev,
                        { nombreId, errorMessage: "" },
                    ]);
                    return true;
                } else {
                    return false;
                }
                default:
                    return false;
        }
    };

    const createSectionList = () => {
        const sections: any = [];
        
        titulosFormulario[activeIndex]?.referenciaFormulario.map((input) => {
            if (!sections[input.seccion]) {
                sections[input.seccion] = [];
            }
            sections[input.seccion].push(input);
        });
        return sections;
    };

    const sectionList = createSectionList();

    const createlistToValidated = () => {
        const sections: any = [];
        
        titulosFormulario[activeIndex]?.referenciaFormulario.map((input) => {
            if (!sections[input.seccion]) {
                sections[input.seccion] = [];
            }
            if (fieldsToSkip?.includes(input.nombreId)) return
            sections[input.seccion].push(input);
        });
        return sections;
    };
    const listToValidated = createlistToValidated();

    // Funcion para renderizar los campos de tipo json provenientes de contentful
    const contentfulRenderOptions = {
        renderNode: {
            [INLINES.HYPERLINK]: ({ data }: any, children) => (
                <a
                    style={{ color: "var(--color-magenta-white)" }}
                    href={data.uri}
                    target={"_blank"}
                    rel={"noopener noreferrer"}
                >
                    {children}
                </a>
            ),
            [BLOCKS.PARAGRAPH]: (node, children) => {
                return <p className="small-note">{children}</p>;
            },
            [BLOCKS.EMBEDDED_ASSET]: (node, children) => {
                return (
                    <p>
                        <img
                            src={`${node.data.target.fields.file.url}`}
                            alt={node.data.target.fields.description}
                        />
                    </p>
                );
            },
        },
        renderText: (text) =>
            text.split("\n").flatMap((line, i) => [i > 0 && <br />, line]),
    };

    useEffect(() => {
        const isSectionValid = listToValidated[Object.keys(listToValidated)[0]]?.every( section => {
            if (!formValues[section.nombreId] && section.obligatorio){
                setdisableBottom(true);
                return false;
            }
            setdisableBottom(false);
            return true;
        });
    
        const isMobileValid = (
            (!('mobile' in formValues) || (formValues.mobile?.length === 10)) && 
            (!('auxNumber' in formValues) || (formValues.auxNumber?.length === 10)) 
        );

        if ('course_selection' in formValues) {
            const isCourseSelectionValid = formValues.course_selection?.split(",").length >= 2;
            setdisableBottom(!(isSectionValid && isMobileValid && isCourseSelectionValid));
        } else if (titulosFormulario.some((formulario) => {
            if (formulario.tituloGeneral === "Servicios") {
                const sections = formulario.referenciaFormulario.map((input) => input.seccion);
                return sections.includes("serviceOptionsTitle") && sections.includes("serviceOptions") && sections.includes("observations");
            }
            return false;
        })) {
            const isSectionObservationValid = listToValidated[Object.keys(listToValidated)[2]]?.every(section => {
                return formValues[section.nombreId] || !section.obligatorio; 
            }) ?? true;  
            
            setdisableBottom(!(isSectionValid && isMobileValid && isSectionObservationValid));
        }
        else {
            setdisableBottom(!(isSectionValid && isMobileValid));
            //habilitador de boton de continuar en modo mobile para portalento.
            if (setDisableStep) {
                setDisableStep(!(isSectionValid && isMobileValid));
            }
        }
    }, [formValues, activeIndex, listToValidated]);

    useEffect(() => {
        if(pathName === 'talleres' || pathName === 'talleres-mentor') {
            selectorSelectDeparment = document.querySelector('#select_deparment');
            selectorSelectMunicipalities = document.querySelector('#select_municipalities');
            selectorButtonSiguiente = document.querySelector('.a-button__magenta');

            if (selectorSelectDeparment && !aceptarTratamiento) {
                selectorSelectDeparment.disabled = true;
            }

            if (selectorSelectMunicipalities && !aceptarTratamiento) {
                selectorSelectMunicipalities.disabled = true;
            }

            if (selectorButtonSiguiente && !aceptarTratamiento) {
                selectorButtonSiguiente.disabled = true;
            }
        }
    }, [[],aceptarTratamiento]);

    useEffect(() => {
        if(formValues.statusJob && formValues.statusDisability === "SÍ" && !listCityAmva.includes(formValues.city)){
            setShowGreenAdvice(false);
            setShowLileAdvice(true);
        }

        if(formValues.statusJob && formValues.statusDisability === "NO" && !listCityAmva.includes(formValues.city)){
            setShowGreenAdvice(true);
            setShowLileAdvice(false);
        }

        if(!formValues.statusJob && !listCityAmva.includes(formValues.city)){
            setShowGreenAdvice(true);
            setShowLileAdvice(false);
        }

        if(listCityAmva.includes(formValues.city)){
            setShowGreenAdvice(true);
            setShowLileAdvice(false);
        }
    }, [formValues]);

    useEffect (() => {
      if (optionEdit){
         setActiveIndex(positionIndex);
         setOptionEdit(false);
      }
    }, [optionEdit])

    const handleRadioChange = (event) => {
        const seleccion = event.target.value;

        if (seleccion === 'no') {
            setAceptarTratamiento(false);

            if (selectorSelectDeparment) {
                selectorSelectDeparment.disabled = true;
            }

            if (selectorSelectMunicipalities) {
                selectorSelectMunicipalities.disabled = true;
            }

            if (selectorButtonSiguiente) {
                selectorButtonSiguiente.disabled = true;
            }
        } else if (seleccion === 'si') {
            setAceptarTratamiento(true);

            if (selectorSelectDeparment) {
                selectorSelectDeparment.disabled = false;
            }

            if (selectorSelectMunicipalities) {
                selectorSelectMunicipalities.disabled = false;
            }

            if (selectorButtonSiguiente) {
                selectorButtonSiguiente.disabled = false;
            }
        }
    };
    
    // Lista los inputs requeridos
    const validateRequired = () => {
        setCustomErrorMessageList([]);
        let inputs: any = Object.entries(
            groupBy(
                titulosFormulario[activeIndex].referenciaFormulario,
                "section"
            )
        )[0][1];

        const fieldsMandatory = inputs.filter(input => {
            return !props.fieldsToSkip?.includes(input.nombreId)
        })

        
        inputs = fieldsMandatory;
        // Agrega los campos no diligenciados a la lista de error
        const errorList: string[] = [];
        inputs.map((input) => {
            if (input.obligatorio && !formValues[input.nombreId]) {
                errorList.push(input.nombreId);
            }

            if (
                inputValidation(
                    input.tipoCampo,
                    formValues[input.nombreId],
                    input.nombreId
                )
            ) {
                errorList.push(input.nombreId);
            }
        });

        //Controla el scroll y lo lleva hasta el campo con error, que no este diligenciado.
        if (errorList.length > 0) {
                document.getElementById(errorList[0])?.scrollIntoView({
                    behavior: "auto",
                    block: "center",
                    inline: "center",
                });
        }
        setInputErrorList(errorList);
        return errorList;
    };

    //Valida que sea sea el index 4 en el formulario de aprendizaje cursos//
    const isInterestedAprendizaje = activeIndex === 4 && pathNameGeneral.includes("/aprendizaje/formulario/cursos/") ;
    //Seccion discapacidad por talento
    const disabilityPorTalento = activeIndex === 3 && pathNameGeneral.includes('por-talento/inscripcion');
    
    return (        
        <div className="m-form-group">
            {/* Titulo del grupo de campos */}
            <div className={`m-form-group__title ${isInterestedAprendizaje ? 'aprendizaje' : ''}`}>
                {isInterestedAprendizaje &&
                    <img className="m-form-group__title aprendizaje__icon" 
                        src={titulosFormulario[activeIndex].referenciaFormulario[0].icon.file.url} 
                        alt={"icono signos de interrogación"}>
                    </img>
                } 
                <h3>{titulosFormulario[activeIndex]?.tituloGeneral === 'Especialidades de cursos' ? 'Modalidad de asistencia al curso': titulosFormulario[activeIndex]?.tituloGeneral}</h3>
            </div>

            {/* Header para formulario Cursos */}
            {activeIndex !== 0 && childHeader}

            {isInterestedAprendizaje &&
                <div className="term-text">
                    <p>{rawToReact(titulosFormulario[activeIndex]?.referenciaFormulario[0].textoTerminos.raw, contentfulRenderOptions)}</p>
                </div>
            }    

            {activeIndex === 0 && titulosFormulario[0].referenciaFormulario[0].nombreId === 'deparment' && 
                    titulosFormulario[0].referenciaFormulario[3]?.nombreId !== 'ruralDistrict' && (
                <div className="terminos-condiciones">
                    <p>Autorizas el tratamiento de tus datos personales.</p>
                    <p>Conoce la política <span className="terminos-condiciones__magenta"><a href="https://serviciosenlinea.comfama.com/webinicio/tratamientodatos.htm" target="_blank">aquí</a></span>. <span className="terminos-condiciones__magenta" >*</span></p>
                    <div className="terminos-condiciones__radio-container">
                        <div className="terminos-condiciones__radio-container__radio-si">
                            <input 
                                type="radio" 
                                value="si"
                                checked={aceptarTratamiento === true}
                                onChange={handleRadioChange}
                            />
                            <span>Sí</span>
                        </div>
                        <div className="terminos-condiciones__radio-container__radio-no">
                            <input 
                                type="radio" 
                                value="no"
                                checked={aceptarTratamiento === false}
                                onChange={handleRadioChange}
                            />
                            <span>No</span>
                        </div>
                    </div>
                </div>
            )}

            {(aceptarTratamiento !== null && !aceptarTratamiento) && (
                <div className="terminos-condiciones">
                    <p className="terminos-condiciones__magenta__aviso">Debes aceptar el tratamiento de datos para poder continuar.</p>
                </div>
            )}

            {formValues.formal_employee && activeIndex === 3 && (
                <div className="m-form-body__container-note">
                    {formValues.formal_employee === 'No' ? (
                        <div className="m-form-body__container-note-inner">
                            <div>
                                <img src={checkSvg} alt="Check"/>
                            </div>
                            <div className="m-form-body__container-note-inner-text">
                                <span>Podrás continuar con la inscripción de talleres y cursos para tu perfil profesional.</span>
                            </div>
                        </div>
                    ) : (
                        <div className="m-form-body__container-note-inner">
                            <div>
                                <img src={checkSvg} alt="Check"/>
                            </div>
                            <div className="m-form-body__container-note-inner-text">
                                <span>Podrás continuar con la inscripción de talleres para tu perfil profesional.</span>
                            </div>
                        </div>
                    )}
                </div>
            )}

            {props.titulosFormulario[activeIndex]?.descripcion && (pathName === 'talleres' || pathName === 'talleres-mentor') ? (
                    <div className="m-form-body__descripcion-talleres">
                        <span>{rawToReact(props.titulosFormulario[activeIndex]?.descripcion.raw, contentfulRenderOptions)}</span>
                    </div>
                ) : props.titulosFormulario[activeIndex]?.descripcion ? (
                    props.titulosFormulario[activeIndex]?.descripcion.raw &&
                    <div className="m-form-body__descripcion">
                        <span>{rawToReact(props.titulosFormulario[activeIndex]?.descripcion.raw, contentfulRenderOptions)}</span>
                    </div>
                ) : null
            }

            {props.titulosFormulario[activeIndex]?.descripcionFija && (
                <div className="m-form-body__descripcion__fija Crema">
                    <svg xmlns="http://www.w3.org/2000/svg" width="27.933" height="27.933" viewBox="0 0 27.933 27.933">
                        <path id="informacion_7_" data-name="informacion (7)" d="M13.966,27.933A13.966,13.966,0,1,0,0,13.966,13.966,13.966,0,0,0,13.966,27.933Zm0-22.113a1.746,1.746,0,1,1-1.746,1.746A1.746,1.746,0,0,1,13.966,5.819ZM12.8,11.639h1.164a2.328,2.328,0,0,1,2.328,2.328v6.983a1.164,1.164,0,1,1-2.328,0V13.966H12.8a1.164,1.164,0,0,1,0-2.328Z" fill="#ee2b7c"/>
                    </svg>
                    {rawToReact(props.titulosFormulario[activeIndex]?.descripcionFija.raw, contentfulRenderOptions)}
                </div>
            )}

            {/* Crea una seccion por cada una de las secciones configuradas para los campos en contentful */}
            <div className={`m-form-group__wrapper m-form-group__wrapper-${activeIndex}`}>
               
                {
                Object.entries(sectionList).map(([section, inputs]) => {
                    return (
                     <>
                        <FormSection
                            key={`section-${section}`}
                            titleSection={section}
                            inputsSection={inputs}
                            setActiveIndex={setActiveIndex}
                            activeIndex={activeIndex}
                            formValues={formValues}
                            setInputValue={setInputValue}
                            inputsErrorList={inputsErrorList}
                            customErrorMessageList={customErrorMessageList}
                            inputDisabled={inputDisabled}
                            validBirthDate={validBirthDate}
                            dateState={dateState}
                            talleresData={talleresData}
                            setDuration={setDuration}
                            dateStateHelper={dateStateHelper}
                            setDateStateHelper={setDateStateHelper}
                            alertMessage={alertMessage}
                            ageAlert={ageAlert}
                        >
                        </FormSection>
                     </>
                    );
                })}
                {(activeIndex === 1 && pathNameMentoria == 'mentoria-de-talento' && showLileAdvice) && (
                    <div className="m-section-form m-section-form-datosPersonales m-section-form-bottom footer-container modality-disability">
                        <p className="footer-text">Tu mentoría será individual, y de acuerdo a la disponibilidad, podrá ser presencial o virtual.</p>
                    </div>
                )}
                {(activeIndex === 1 && pathNameMentoria === 'mentoria-de-talento' && showGreenAdvice) && (
                    <div className="m-section-form m-section-form-datosPersonales m-section-form-bottom footer-container modality">
                        <div className="m-section-form__virtual">
                            <img src="https://images.ctfassets.net/203frbsx1z3n/4YjWklo6R4Gh2AWQ19uUBz/ed1839d398fa7fbe312a9a195ae14ed4/Icon_Aprendizajr.svg"/>
                            <p className="footer-text">Para la modalidad virtual deberás contar con acceso a internet y a un dispositivo como computador o celular que te permita conectarte al espacio.</p>
                        </div>
                        <div className="m-section-form__presencial">
                            <img src="https://images.ctfassets.net/203frbsx1z3n/4YjWklo6R4Gh2AWQ19uUBz/ed1839d398fa7fbe312a9a195ae14ed4/Icon_Aprendizajr.svg"/>
                            <p className="footer-text">Para la modalidad presencial deberás contar con el tiempo y recursos para desplazarte al lugar en el cual se llevará a cabo la mentoría de talento.</p>
                        </div>
                    </div>
                )}
                {disabilityPorTalento && (
                    <div className="support-tools__content">
                        <h2 className="support-tools__title">Ejemplos de algunas herramientas de apoyo:</h2>
                        <div className="support-tools__items">
                            <div className="support-tools__item">
                                <img src="https://images.ctfassets.net/203frbsx1z3n/lQbFY8bYXMdc9F8IYazwD/8713f9a9bc42c48786ccde246c191924/baston.svg" alt="Bastón" className="support-tools__icon" />
                                <p className="support-tools__label">Bastón</p>
                            </div>
                            <div className="support-tools__item">
                                <img src="https://images.ctfassets.net/203frbsx1z3n/50q9DdBZjJJ1sj3kaEUqmq/fcf024944192fc6e69316ec17ee3fbb3/silla_de_ruedas.svg" alt="Silla de ruedas" className="support-tools__icon" />
                                <p className="support-tools__label">Silla de ruedas</p>
                            </div>
                            <div className="support-tools__item">
                                <img src="https://images.ctfassets.net/203frbsx1z3n/1TrCAZpX1Lv0D5h54fm6Gb/e117c133cae3907818d2f72721aa81aa/dispositivo_audicion.svg" alt="Audífono" className="support-tools__icon" />
                                <p className="support-tools__label">Audífono</p>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            
            {/* Renderiza autorizacion de datos, botones de confirmacion/navegacion en la parte inferior */}
            {childOptions}
            {
                <FormBottom
                    inputs={titulosFormulario[activeIndex]?.referenciaFormulario}
                    titleButton={tituloBoton || titulosFormulario[activeIndex]?.tituloBoton}
                    activeWizard={activeWizard}
                    setActiveIndex={setActiveIndex}
                    activeIndex={activeIndex}
                    endIndex={endIndex}
                    validateRequired={validateRequired}
                    setInputValue={setInputValue}
                    formValues={formValues}
                    inputsErrorList={inputsErrorList}
                    handleSubmitForm={handleSubmitForm}
                    // isDisabled={disableBottom}
                    handleEvent={handleEvent}
                    isDisabled={disableBottom || isDisabledButton}
                    onclick={onclick}
                    getActiveIndex={getActiveIndex}
                    handleCancelButton={handleCancelButton}
                    setCurrentIndex={setCurrentIndex}
                ></FormBottom>
            }
        </div>
    );
};

export default FormGroup;
